import { notification } from "antd";
import { defineMessages, IntlShape } from "react-intl";

interface IProps {
    intl: IntlShape;
    reset: () => void;
}

const MESSAGES = defineMessages({
    productsNotFound: {
        id: "products_not_found_notification.message",
        defaultMessage: "Geen producten gevonden voor deze referentie"
    }
});

export const ProductsNotFoundNotification = (props: IProps) => {
    notification.error({
        message: props.intl.formatMessage(MESSAGES.productsNotFound),
        onClose: () => props.reset(),
        placement: "bottomRight",
    });
    return null;
};
